import { gql } from 'apollo-boost';

export const deleteCustomPortal = gql`
  mutation deleteCustomPortal($id: Int!) {
    deleteCustomPortal(id: $id) {
      success
    }
  }
`;
